import { getBorderRadius } from '$lib/global/helper/border-radius';
import { getShadow } from '$lib/global/helper/shadow';
import { getColorByLightness } from '$lib/helper';

import { isUsableColor } from '../../_utils/color';

import type { BrandBorderRadius, BrandShadow, Theme } from '$lib/types/Theme';

export interface ResolvedMultipleChoiceAnswerStyling {
    bgColor: string;
    borderColorStyle: string | undefined;
    borderRadiusClass: string;
    selectedColor: string;
    shadowClass: string | undefined;
    textColor: string;
}

interface Params {
    theme: Theme;
    bgColor: string;
    color: string;
    selectedColor: string;
}

const resolveBgColor = (theme: Theme, perAnswer: string): string => {
    if (isUsableColor(perAnswer)) {
        return perAnswer;
    }

    if (theme.surface) {
        return theme.surface;
    }

    return theme.formFieldBackgroundColor;
};

const resolveSelectedColor = (theme: Theme, perAnswer: string): string => {
    if (isUsableColor(perAnswer)) return perAnswer;
    return theme.buttonBackgroundColor;
};

const resolveTextColor = (theme: Theme, perAnswer: string, bgColor: string): string => {
    const isThemeV2 = !!theme?.surface;

    if (isUsableColor(perAnswer)) {
        return perAnswer;
    }

    if (isThemeV2 && theme.fontColor) {
        return theme.fontColor;
    }

    return getColorByLightness(bgColor);
};

export const resolveMultipleChoiceAnswerStyling = ({
    theme,
    bgColor,
    color,
    selectedColor,
}: Params): ResolvedMultipleChoiceAnswerStyling => {
    const resolvedBgColor = resolveBgColor(theme, bgColor);

    return {
        bgColor: resolvedBgColor,
        borderColorStyle: theme.border || undefined,
        borderRadiusClass: getBorderRadius(
            'choiceItem',
            theme.borderRadius as BrandBorderRadius | undefined,
        ),
        selectedColor: resolveSelectedColor(theme, selectedColor),
        shadowClass: theme.shadow
            ? getShadow('choiceItem', theme.shadow as BrandShadow)
            : undefined,
        textColor: resolveTextColor(theme, color, resolvedBgColor),
    };
};
